/**
 * Layout / surface tokens for the Organisation portal shell and dashboard cards.
 * Aligned with Figma "New Org Portal" (file key xPJGBTEQ6JrzDxijJBaYCq): teal stroke #004b4d,
 * active nav wash rgba(207,235,205,0.4), 30px corner radius on cards and nav pills.
 */
export const portalTealBorder = 'border border-portal-teal';

/** Shared corner radius for portal buttons / nav pills (12px). */
export const portalButtonRadius = 'rounded-[12px]';

export const portalNavPillBase =
  `${portalTealBorder} ${portalButtonRadius} bg-pure-white text-portal-teal ` +
  'flex w-fit sm:w-full items-center px-md py-sm sm:px-lg sm:py-md mb-md font-bold font-sans-co ' +
  'hover:no-underline visited:text-portal-teal active:text-portal-teal';

export const portalNavPillActive =
  `${portalTealBorder} ${portalButtonRadius} bg-portal-nav-active text-portal-teal ` +
  'flex w-fit sm:w-full items-center px-md py-sm sm:px-lg sm:py-md mb-md font-bold font-sans-co ' +
  'hover:no-underline visited:text-portal-teal active:text-portal-teal';

export const portalCardSurface = `bg-pure-white ${portalTealBorder} rounded-portal shadow-none`;

/** Page title (Co Headline, ~48px on large screens). */
export const portalPageTitle =
  'font-sans-co font-bold text-portal-teal text-[2rem] leading-tight sm:text-[3rem]';

/** Intro / subtitle under page title. */
export const portalPageSubtitle = 'text-p1 text-portal-teal font-normal max-w-3xl';

/** Card wrapper around data tables. */
export const portalTableCard = `${portalCardSurface} overflow-hidden`;

/** Bordered table area that scrolls when rows exceed max height (e.g. Billing lists). */
export const portalTableCardScrollable =
  `${portalCardSurface} max-h-[min(28rem,55vh)] overflow-y-auto overflow-x-auto`;

/** Table header cells (first row). */
export const portalTableHeadCell =
  'px-md py-sm text-left text-p2 font-medium text-portal-teal border-b border-portal-teal bg-portal-header-wash';

/** Body row striping aligned with portal palette. */
export const portalTableBodyRow =
  'text-left text-portal-teal odd:bg-pure-white even:bg-portal-header-wash/40';

/** Standard body cell. */
export const portalTableBodyCell = 'px-md py-sm align-middle border-b border-portal-teal/10';

/** Small outline control (Figma CSV row / “Add” pill). */
export const portalOutlineControl =
  'w-full rounded-portal border border-portal-teal border-solid bg-pure-white px-sm py-xs text-p2 text-portal-teal ' +
  'placeholder-mid-grey read-only:cursor-pointer';

/** Secondary text button / link styled as portal pill. */
export const portalSecondaryPillButton =
  `inline-flex items-center justify-center ${portalButtonRadius} border border-portal-teal border-solid bg-pure-white ` +
  'px-lg py-md font-sans-co text-p2 font-bold text-portal-teal visited:text-portal-teal ' +
  'hover:bg-super-light-grey no-underline hover:no-underline cursor-pointer';
